<template>
  <div class="lcu-mobile-controls" :class="{
      'lcu-mobile-controlsIOS': _device.iPhone && _device.app,
    }">
    <div class="lcu-flex-left">
      <a
        href="#"
        @click.prevent="checkLink('/cuenta/perfil')"
        class="lcu-mobile-profile">
        <shimmer-circle v-if="userLoading" />
        <img
          class="lcu-profile-pic"
          v-if="user.profilePic && !userLoading"
          :src="user.profilePic"
          alt="profile picture" />
        <img
          class="lcu-profile-pic"
          v-if="!user.profilePic && !userLoading"
          src="./default-profile.svg"
          alt="profile picture" />
      </a>
    </div>
    <div class="lcu-flex-center">
      <header class="lcu-mobile-header">
        Legacy Christian University
      </header>
    </div>
    <div class="lcu-flex-right">
      <button
        type="button"
        class="lcu-mobile-button lcu-mobile-menu"
        :class="{ 'lcu-mobile-close': dropdown }"
        @click.prevent="dropdown = !dropdown"
        name="drop-down">
      </button>
      <div class="lcu-mobile-dd" :class="{ 'lcu-dd-open': dropdown }">
        <div class="lcu-dd-logo">
          <img
            src="/assets/lcu-logo-gold.svg"
            alt="LCU Logo" />
        </div>
        <div class="lcu-dd-links">
          <a
            v-if="user.id"
            href="#"
            @click="logout"
            class="lcu-dd-link lcu-icon-logout">
            Cerrar sesión
          </a>
          <router-link
            v-if="!user.id"
            class="lcu-dd-link lcu-icon-login"
            to="/iniciar-sesion">
            Iniciar sesión
          </router-link>
        </div>
      </div>
    </div>
  </div>
  <LoginModal @set-modal="loginModal = false" :login-modal="loginModal" />
</template>

<script>
import { mapGetters } from 'vuex';
import LoginModal from 'ç/login-modal/LoginModal.vue';
import Auth from '@/mixins/Auth.vue';
import ShimmerCircle from 'ç/loaders/shimmers/Circle.vue';

export default {
  name: 'mobile-top-controls',
  components: {
    ShimmerCircle,
    LoginModal,
  },
  mixins: [Auth],
  computed: {
    ...mapGetters(['user', 'userLoading']),
  },
  data() {
    return {
      dropdown: false,
      loginModal: false,
    };
  },
  methods: {
    goToAdmin() {
      this.$router.push({ path: '/admin' });
    },
    async logout() {
      this.dropdown = false;
      await this.$logout();
      this.$router.push({ path: '/iniciar-sesion' });
      setTimeout(() => {
        this.$clearAuthStorage();
        this.$store.dispatch('logoutUser');
      }, 300);
    },
    checkLink(path) {
      if (!this.user.id) {
        this.loginModal = true;
        window.localStorage.setItem('lcuRequestedPath', path);
      } else {
        this.$router.push({ path });
      }
    },
    onResultClick() {
      this.dropdown = false;
    },
  },
};
</script>

<style scoped lang="scss">
.lcu-mobile-controls {
  background-color: $legacy-primary;
  border-bottom: 1px solid rgba($white, .2);
  display: none;
  height: 50px;
  grid-template-columns: max-content 1fr max-content;
  left: 0;
  margin-bottom: 20px;
  padding: 5px 20px;
  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
  z-index: 5;

  @media only screen and (max-width: $mobile-max) {
    display: grid;
  }
}

.lcu-mobile-controlsIOS {
  top: 55px;
}

.lcu-dd-logo {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 10px;
  border-bottom: 1px solid $gray-lightest;
  padding-bottom: 10px;

  img {
    width: 50px;
  }
}

.lcu-mobile-profile {
  display: flex;
}

.lcu-profile-pic {
  border-radius: 50%;
  width: 35px;
}

.lcu-profile-link {
  display: inline-block;
  margin-left: 15px;
}

.lcu-mobile-header {
  color: $white;
  font-size: 13px;
  white-space: nowrap;
}

.lcu-mobile-button {
  background-color: transparent;
  border: 1px solid rgba($white, .2);
  color: rgba($white, .8);
  margin-left: 8px;
  padding: 10px;
  z-index: 2;

  &:after {
    font-family: 'lcu';
  }
}

.lcu-mobile-menu {

  &:after {
    content: '\e810';
  }
}

.lcu-mobile-close {

  &:after {
    content: '\e811';
  }
}

.lcu-mobile-dd {
  background-color: $white;
  border-bottom: 1px solid rgba($black, .2);
  height: 0;
  left: 0;
  overflow: hidden;
  padding: 10px 20px;
  pointer-events: none;
  position: fixed;
  right: 0;
  top: 50px;
  transition-duration: .2s;
  visibility: hidden;
  width: 100%;
}

.lcu-mobile-controlsIOS {
  .lcu-mobile-dd {
    top: 105px;
  }
}

.lcu-dd-open {
  height: 100%;
  pointer-events: initial;
  visibility: visible;
}

.lcu-dd-links {
  padding-top: 10px;
  text-align: center;
}

.lcu-dd-link {
  color: $legacy-primary;
  display: block;
  margin-bottom: 15px;
  padding: 10px;
  text-decoration: none;

  &:before {
    display: inline-block;
    font-family: 'lcu';
    margin-right: 10px;
  }

  &:last-child {
    margin-bottom: 0;
  }
}

.lcu-icon-admin {

  &:before {
    content: '\e814';
  }
}

.lcu-icon-logout {

  &:before {
    content: '\e813';
  }
}

.lcu-icon-login {

  &:before {
    content: '\e815';
  }
}

// .lcu-dd-active {

//   &:before {
//     color: $bronze;
//   }
// }
</style>
